import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import useAuthListener from '../utils/Hooks/useAuthListener';
import ProtectedRoute from './ProtectedRoute';
import RoleProtectedRoute from './RoleProtectedRoute';
import PublicRoute from './PublicRoute';
import { Dashboard, AdminShiftView, Onboarding, People, Login, Loading, Reports, Venues } from '../pages';
import DashboardLayout from './DashboardLayout';
import { PRIVILEGED_ROLES } from '../utils/constants/roles';

const AppRoutes = () => {
  useAuthListener();
  const { isAuthenticated, isOnboardingComplete } = useSelector((state) => state.currentUser);
  const showLayout = isAuthenticated && isOnboardingComplete;

  return (
    <Routes>
      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout showLayout={showLayout}>
              <Dashboard />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/shifts"
        element={
          <ProtectedRoute>
            <DashboardLayout showLayout={showLayout}>
              <AdminShiftView />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/people/:personId?"
        element={
          <ProtectedRoute>
            <DashboardLayout showLayout={showLayout}>
              <People />
            </DashboardLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <RoleProtectedRoute allowedRoles={PRIVILEGED_ROLES}>
            <DashboardLayout showLayout={showLayout}>
              <Reports />
            </DashboardLayout>
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/venues"
        element={
          <RoleProtectedRoute allowedRoles={PRIVILEGED_ROLES}>
            <DashboardLayout showLayout={showLayout}>
              <Venues />
            </DashboardLayout>
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <Onboarding />
          </ProtectedRoute>
        }
      />
      <Route
        path="/loading"
        element={
          <ProtectedRoute>
            <Loading />
          </ProtectedRoute>
        }
      />

      {/* Public Routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
